export enum Roles {
  ADMIN = 'admin',
  SUPPORT = 'support',
  RETAIL = 'retail'
}

export const roles = [
  { value: Roles.SUPPORT, label: 'Support' },
  { value: Roles.ADMIN, label: 'Admin' },
  { value: Roles.RETAIL, label: 'Retail' }
];

export const allOption = {
  label: 'All',
  value: 'all'
};

export const tablePageQty = 100;

export const primaryColor = '#2f3440';
export const secondaryColor = '#dd7e43';
export const disableColor = '#f6f6f6';
export const disableGrayColor = '#a7a19d';
export const groundColor = 'white';
export const chartGreenColor = '#91c559';
export const chartBlueColor = '#577ecb';
export const chartRedColor = '#ff3333';
export const chartOrangeColor = '#ffc200';

export const nsItemURL =
  'https://969904.app.netsuite.com/app/common/item/item.nl?id=';

export const formatCurrency = (num: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(num);

export const formatFullMonthDate = (num: Date) =>
  new Intl.DateTimeFormat('en', {
    month: 'long',
    year: 'numeric'
  }).format(num);

export const formatShortMonthDate = (num: Date) =>
  new Intl.DateTimeFormat('en', {
    month: 'short',
    year: 'numeric'
  }).format(num);

export const formatNumber = (num: number) =>
  new Intl.NumberFormat('en-US').format(num);

export const npcTypes = {
  fbaFreight: {
    name: 'FBA Freight',
    value: 2
  },
  inboundFreight: {
    name: 'Inbound Freight',
    value: 1
  },
  fbaStorage: {
    name: 'FBA Storage Fee',
    value: 6
  },
  fbaLongStorage: {
    name: 'Amazon Long Term Storage Fee',
    value: 7
  },
  fbaShortStorage: {
    name: 'Amazon Long Term Short Time Storage Fee',
    value: 15
  }
};
